module.exports = __webpack_public_path__ + "media/landing_page/iframe_embed-e8b54f18.svg";